<template lang="pug">
  div
    b-row
      //- .col-xl-4
      //-   panel(:title='$t("ui.profile")')
      //-     Profile
      .col-xl-4
        panel(:title='$t("ui.password")')
          ChangePassword
        panel(:title='$t("ui.security_code")')
          SecurityCode
      .col-xl-4
        panel(:title='$t("ui.setup_otp_via_mobile_authenticator")')
          Otp2fa
</template>

<script>
// import Profile from "@/components/settings/profile";
import ChangePassword from "@/components/settings/changePassword";
import SecurityCode from "@/components/settings/securityCode";
import Otp2fa from "@/components/settings/otp2fa";

export default {
  components: {
    // Profile,
    ChangePassword,
    SecurityCode,
    Otp2fa
  },
  computed: {
    is2faBound() {
      const twoFactorStatus = this.$store.getters.get2faValidated;
      return twoFactorStatus === true || twoFactorStatus === 1;
    }
  }
}
</script>
